import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const PromotionTagValidation = z.object({
  text: z.string({ required_error: '[PromotionTag} text value is required' }),
  background: z.string({ required_error: '[PromotionTag] background value is required' }),
  color: z.string({ required_error: '[PromotionTag] endDate value is required' }),
})

export class PromotionTag extends Model {
  static create({ text, background, color }: z.infer<typeof PromotionTagValidation>) {
    PromotionTagValidation.parse({ text, background, color })
    return new PromotionTag(text, background, color, false)
  }

  static fromJSON({ json }: { json: ReturnType<PromotionTag['toJSON']> }) {
    return new PromotionTag(json.text, json.background, json.color, !json.text)
  }

  static empty() {
    return new PromotionTag('', '', '', true)
  }

  constructor(
    private readonly _text: string,
    private readonly _background: string,
    private readonly _color: string,
    private readonly _empty: boolean
  ) {
    super()
  }

  get text() { return this._text } // prettier-ignore
  get background() { return this._background } // prettier-ignore
  get color() { return this._color } // prettier-ignore

  isEmpty() {
    return this._empty
  }

  toJSON() {
    return {
      text: this.text,
      background: this.background,
      color: this.color,
    }
  }
}
